import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface RejectBusinessUnitRelationReception {
  actionName: 'rejectBusinessUnitRelationReception';
  request: mtechnavi.api.company.IRejectBusinessUnitRelationReceptionRequest;
}

export const rejectBusinessUnitRelationReception = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IRejectBusinessUnitRelationReceptionRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/RejectBusinessUnitRelationReception';

  const result = await worker.invokeListRequest(execMethodName, {
    businessUnitManagementId: req.businessUnitManagementId,
  });
  return result;
};
